import React from 'react';

const PlantingPreview = ({ bedWidth, bedLength, numRows, plantsPerRow, label, iconUrl }) => {
    const xmlns = "http://www.w3.org/2000/svg";
    const svgWidth = bedWidth;
    const svgHeight = bedLength;
    const rowSpacing = bedLength / (numRows + 1);
    const plantSpacing = bedWidth / (plantsPerRow + 1);

    // Calculate icon size based on spacing (smaller of row or plant spacing, capped at reasonable size)
    const iconSize = Math.min(Math.min(rowSpacing, plantSpacing) * 0.8, 20);
    const showPerPlantIcon = iconUrl && iconSize >= 6;
    // For dense crops where per-plant icons are too small, show a single centered icon
    const showCenteredIcon = iconUrl && !showPerPlantIcon;
    const centeredIconSize = Math.min(Math.min(svgWidth, svgHeight) * 0.35, 40);

    const circlesAndLines = [];

    for (let row = 1; row <= numRows; row++) {
        let prevCx = null;
        let prevCy = null;

        for (let plant = 1; plant <= plantsPerRow; plant++) {
            let cx = plant * plantSpacing;
            let cy = row * rowSpacing;

            if (showPerPlantIcon) {
                circlesAndLines.push(
                    <image
                        key={`icon-${row}-${plant}`}
                        href={iconUrl}
                        x={cx - iconSize / 2}
                        y={cy - iconSize / 2}
                        width={iconSize}
                        height={iconSize}
                    />
                );
            } else {
                circlesAndLines.push(
                    <circle key={`circle-${row}-${plant}`} cx={cx} cy={cy} r={2} fill="black" />
                );
            }

            if (prevCx !== null && prevCy !== null && !iconUrl) {
                circlesAndLines.push(
                    <line key={`line-${row}-${plant}`} x1={prevCx} y1={prevCy} x2={cx} y2={cy} stroke="black" strokeWidth={1} />
                );
            }

            prevCx = cx;
            prevCy = cy;
        }
    }

    return (
        <svg xmlns={xmlns} width={svgWidth} height={svgHeight} viewBox={`0 0 ${svgWidth} ${svgHeight}`}>
            <rect x={0} y={0} width={svgWidth} height={svgHeight} fill="none" stroke="none" />
            {circlesAndLines}
            {showCenteredIcon && centeredIconSize >= 10 && (
                <image
                    href={iconUrl}
                    x={(svgWidth - centeredIconSize) / 2}
                    y={(svgHeight - centeredIconSize) / 2}
                    width={centeredIconSize}
                    height={centeredIconSize}
                    opacity={0.6}
                />
            )}
            {label && (
                <>
                    <defs>
                        <filter x="-0.05" y="-0.1" width="1.1" height="1.2" id="label-bg">
                            <feFlood floodColor="white" floodOpacity="1" result="bg" />
                            <feMerge>
                                <feMergeNode in="bg" />
                                <feMergeNode in="SourceGraphic" />
                            </feMerge>
                        </filter>
                    </defs>
                    <text x="50%" y="25%" textAnchor="middle" dominantBaseline="middle" fontSize="14" fill="black" filter="url(#label-bg)">
                        {label}
                    </text>
                </>
            )}
        </svg>
    );
};

export default PlantingPreview;
